import { useStatus } from '../hooks/useStatus';
import { formatNumber } from '../util/format';
import { Link } from 'react-router-dom';

export const NetworkStatusBar = () => {
  const { data: status, loading, error } = useStatus();

  if (loading && !status) {
    return (
      <div className="network-status">
        <div
          className="status-item skeleton"
          style={{ height: 40, flex: '1 0 200px' }}
        />
        <div
          className="status-item skeleton"
          style={{ height: 40, flex: '1 0 200px' }}
        />
      </div>
    );
  }

  if (error || !status) {
    return (
      <div className="network-status">
        <p style={{ color: '#888' }}>Network status unavailable</p>
      </div>
    );
  }

  const frontierHeight = status.utxo.chainlock.height;
  const utxoTip = status.utxo.indexed_height;

  // Calculate ChainLock lag and status (only show red warning when lag is significant)
  const chainlockLag = frontierHeight != null ? utxoTip - frontierHeight : null;
  const showWarning = chainlockLag != null && chainlockLag >= 15;

  const frontierDisplay = frontierHeight != null ? formatNumber(frontierHeight) : 'N/A';

  const syscoinPercent =
    status.utxo.indexed_height > 0
      ? ((status.utxo.blocks_indexed / status.utxo.indexed_height) * 100).toFixed(1)
      : 'N/A';

  const avgBlockTimeMinutes = status.utxo.avg_block_time_seconds
    ? (status.utxo.avg_block_time_seconds / 60).toFixed(2)
    : null;

  return (
    <div className="network-status">
      <div className="status-item">
        <div className="status-label">Bitcoin Height</div>
        <div className="status-value">
          {formatNumber(status.bitcoin.indexed_height)}
        </div>
      </div>
      <div className="status-item">
        <div className="status-label">UTXO Height</div>
        <div className="status-value">
          {formatNumber(status.utxo.indexed_height)}
        </div>
      </div>
      <Link
        to="/chainlocks"
        className="status-item status-link"
      >
        <div className="status-label">
          ChainLock Height
        </div>
        <div className="status-value">
          {frontierDisplay}
          {showWarning && (
            <span style={{ marginLeft: '0.25rem', color: '#FF5252' }}>⚠</span>
          )}
        </div>
      </Link>
      <div className="status-item">
        <div className="status-label">NEVM Height</div>
        <div className="status-value">
          {formatNumber(status.nevm.indexed_height)}
        </div>
      </div>
      <div className="status-item">
        <div className="status-label">Avg Block Time</div>
        <div className="status-value">
          {avgBlockTimeMinutes ? `${avgBlockTimeMinutes} min` : 'N/A'}
        </div>
      </div>
      <div className="status-item">
        <div className="status-label">Indexing Progress</div>
        <div className="status-value highlight">
          {syscoinPercent !== 'N/A' ? `${syscoinPercent}%` : 'N/A'}
        </div>
      </div>
      <Link
        to="/mining"
        className="status-item status-link"
      >
        <div className="status-label">Mining Pools</div>
        <div className="status-value">
          {formatNumber(status.miners.known)}+
        </div>
      </Link>
      <a
        href="https://www.coinwarz.com/mining/syscoin/hashrate-chart"
        target="_blank"
        rel="noopener noreferrer"
        className="status-item status-link"
      >
        <div className="status-label">Hashrate</div>
        <div className="status-value">
          {status.hashrate?.formatted || 'N/A'}
        </div>
      </a>
    </div>
  );
};
